export const trans_14_1=[
  {
    id:1,
    english:'I am waiting for a taxi',
    vietnamese:'Tôi đang đợi taxi',
    user_message:''
  },
  {
    id:2,
    english:'She is feeling a bit tired',
    vietnamese:'Cô ấy đang cảm thấy hơi mệt',
    user_message:''
  },
  {
    id:3,
    english:'Are you driving to my house tonight?',
    vietnamese:'Bạn có lái xe đến nhà tôi tối nay không?',
    user_message:''
  },
  {
    id:4,
    english:'We are looking for Beckham on the street',
    vietnamese:'Chúng tôi đang đợi Beckham trên đường phố',
    user_message:''
  }, 

]

export const trans_14_2=[
  {
    id:1,
    english:'Is your flight safe? Yes! It is very safe',
    vietnamese:'Chuyên bán của bạn có an toàn không? Có! Nốt rất an toàn.',
    user_message:''
  },
  {
    id:2,
    english:'Can I borrow this trolley?',
    vietnamese:'Tôi có thể mượn chiếc xe đẩy này không?',
    user_message:''
  },
  {
    id:3,
    english:'We are standing in the hall of the company',
    vietnamese:'Chúng ta đang đứng tại sảnh công ty',
    user_message:''
  },
  {
    id:4,
    english:'What I need to prepare for the meeting? You need to prepare some documents',
    vietnamese:'Tôi cần chuẩn bị gì cho cuộc họp? Bạn cần chuẩn bị một vài tài liệu',
    user_message:''
  }, 
]